import emailjs from '@emailjs/browser';

const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_USER = process.env.REACT_APP_EMAILJS_TEMPLATE_USER_ID;
const TEMPLATE_OWNER = process.env.REACT_APP_EMAILJS_TEMPLATE_OWNER_ID;

export async function sendUserThanks(params) {
  console.log("🚀 ~ sendUserThanks ~ params:", params);

  if (!SERVICE_ID || !TEMPLATE_USER || !PUBLIC_KEY) {
    throw new Error('EmailJS not configured properly');
  }
  return emailjs.send(
    SERVICE_ID,
    TEMPLATE_USER,
    params,
    PUBLIC_KEY
  );
}

export async function sendOwnerNotification(params) {
  console.log("🚀 ~ sendOwnerNotification ~ params:", params);

  if (!SERVICE_ID || !TEMPLATE_OWNER || !PUBLIC_KEY) {
    throw new Error('EmailJS not configured properly');
  }

  return emailjs.send(
    SERVICE_ID,
    TEMPLATE_OWNER,
    params,
    PUBLIC_KEY
  );
}
